import React from 'react';
import {z} from 'zod';

import {ViewColumnOutlined} from '@mui/icons-material';

import {ColumnsContainer,ColumnsContainerPropsSchema} from './ColumnsContainer';
import ColumnsContainerSidebarPanel from './ColumnsContainerSidebarPanel';

export type ColumnsContainerProps = z.infer<typeof ColumnsContainerPropsSchema>;

export default {
    label: 'Columns',
    icon: <ViewColumnOutlined />,
    type: 'ColumnsContainer',
    defaultData: {
        props: {
            fixedWidths: [null,null,null],
            columnsGap: 16,
            columnsCount: 3,
            contentAlignment: 'middle',
            columns: [{ childrenIds: [] }, { childrenIds: [] }, { childrenIds: [] }],
            tableWidth: 100,
        },
        style: { padding: { top: 16, bottom: 16, left: 24, right: 24 } },
    },
    SidebarPanel: ColumnsContainerSidebarPanel,
    Component: ColumnsContainer,
    schema: ColumnsContainerPropsSchema,
};